import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import AnchorLink from '../../../components/AnchorLink';
import styles from './PromoText.module.scss';
export const capitaliseFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
const PromoText = ({ data, oversized, clickAction, link, wrappedByLink }) => {
    const { theme } = data;
    const sizeSuffix = oversized ? ` ${styles.oversized}` : '';
    const hasHeading = data.heading || data.headingHighlight;
    let textTheme = theme ? `wrapper${capitaliseFirstLetter(theme)}` : 'wrapper';
    let textArea = null;
    if (wrappedByLink)
        textTheme += 'Nested';
    textArea = (React.createElement("div", { className: styles[textTheme] + sizeSuffix },
        hasHeading && (React.createElement(Typography, { element: "h3", styleAs: "sectionHeading", noMargins: true, className: styles.title },
            data.headingHighlight && (React.createElement("span", { className: styles.titleHighlight },
                data.headingHighlight,
                " ")),
            data.heading)),
        data.subheading && (React.createElement(Typography, { element: "p", styleAs: "paragraph", noMargins: true, className: styles.byline }, data.subheading))));
    if (link && data.callToActionURL) {
        const linkProps = {
            'aria-label': data.callToActionAltText,
            className: styles[`${textTheme}Link`] + sizeSuffix,
            onClick: () => clickAction(data),
            href: data.callToActionURL,
        };
        textArea = (React.createElement(AnchorLink, Object.assign({}, linkProps),
            data.heading && (React.createElement(Typography, { element: "h3", styleAs: "sectionHeading", noMargins: true, className: styles.title },
                data.headingHighlight && (React.createElement("span", { className: styles.titleHighlight },
                    data.headingHighlight,
                    " ")),
                data.heading)),
            data.subheading && (React.createElement(Typography, { element: "p", styleAs: "paragraph", noMargins: true, className: styles.byline }, data.subheading))));
    }
    return textArea;
};
PromoText.propTypes = {
    cells: PropTypes.string,
    clickAction: PropTypes.func,
    data: PropTypes.object.isRequired,
    link: PropTypes.bool,
    theme: PropTypes.oneOf(['dark', 'light']),
    wrappedByLink: PropTypes.bool,
};
export default PromoText;
//# sourceMappingURL=PromoText.js.map